import React, { Component } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import { toast } from 'react-toastify';
import GTradesTable from './gtradesTable';
import {
  getCardTrades,
  deleteCardTrade,
  tradeCompletionStatus,
  tradeApprovalStatus,
} from '../services/cardTradeService';
import auth from '../services/authService';
import Spinner from './common/spinner';
import NotFound from './notFound';
import Alert from './common/alert';
import AddButton from './common/addButton';

class GTrades extends Component {
  state = {
    gtrades: [],
    loading: false,
  };

  async componentDidMount() {
    this.setState({ loading: true });
    const gtrades_response = await getCardTrades();
    this.setState({ loading: false });
    console.log(gtrades_response.data.data);
    const { data: gtrades } = gtrades_response.data;
    this.setState({ gtrades });
  }

  handleDelete = async (gtrade) => {
    const originalCardTrades = this.state.gtrades;
    const gtrades = originalCardTrades.filter((g) => g._id !== gtrade._id);
    this.setState({ gtrades });

    try {
      confirmAlert({
        customUI: ({ onClose }) => {
          return (
            <Alert
              name="Gift Card Trade"
              onClose={() => {
                this.setState({ gtrades: originalCardTrades });
                onClose();
              }}
              onDelete={async () => {
                await deleteCardTrade(gtrade._id);
                onClose();
              }}
            />
          );
        },
      });
    } catch (ex) {
      if (ex.response && ex.response.status === 404)
        toast('This Trade has already been deleted.');

      this.setState({ gtrades: originalCardTrades });
    }
  };

  handleTradeCompletionSwitch = async (gtrade) => {
    const gtrades = [...this.state.gtrades];
    const index = gtrades.indexOf(gtrade);
    gtrades[index] = { ...gtrades[index] };
    //console.log(users[index]);
    gtrades[index].isCompleted = !gtrades[index].isCompleted;
    await tradeCompletionStatus(gtrades[index]);
    this.setState({ gtrades });
  };

  handleTradeApprovalSwitch = async (gtrade) => {
    const gtrades = [...this.state.gtrades];
    const index = gtrades.indexOf(gtrade);
    gtrades[index] = { ...gtrades[index] };
    //console.log(users[index]);
    gtrades[index].isApproved = !gtrades[index].isApproved;
    await tradeApprovalStatus(gtrades[index]);
    this.setState({ gtrades });
  };

  getPagedData = () => {
    const { gtrades } = this.state;

    return { data: gtrades };
  };

  render() {
    const { loading } = this.state;
    const { data: gtrades } = this.getPagedData();
    const { isAdmin } = auth.getCurrentUser();
    if (loading) return <Spinner message="loading page data..." />;
    return isAdmin ? (
      <React.Fragment>
        <AddButton link="/closed-trades/new" value="Close a trade" />
        <GTradesTable
          gtrades={gtrades}
          onCompleteSwitch={this.handleTradeCompletionSwitch}
          onApproveSwitch={this.handleTradeApprovalSwitch}
          onDelete={this.handleDelete}
          message="Card Trades"
        />
      </React.Fragment>
    ) : (
      <NotFound />
    );
  }
}

export default GTrades;
